import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    setOrdreMissionLoading,
    fetchOrdreMissionSuccess,
    fetchOrdreMissionFail,
    fetchOrdreMissionByIdSuccess,
    fetchOrdreMissionByIdFail,
    createOrdreMissionSuccess,
    createOrdreMissionFail,
    updateOrdreMissionSuccess,
    updateOrdreMissionFail,
    deleteOrdreMissionSuccess,
    deleteOrdreMissionFail,
    fetchOrdreMissionActifsSuccess,
    fetchOrdreMissionActifsFail,
    fetchOrdreMissionEnCoursSuccess,
    fetchOrdreMissionEnCoursFail,
    fetchOrdreMissionByPeriodSuccess,
    fetchOrdreMissionByPeriodFail,
} from "../actions/ordreMissionActions";

const extractErrorMessage = (error, fallback) => {
    let msg = fallback;

    if (error?.response?.data?.message) msg = error.response.data.message;
    else if (error?.response?.data?.error) msg = error.response.data.error;
    else if (error?.message) msg = error.message;

    return msg;
};

// ===================== FETCH ALL =====================
export function* fetchOrdreMissionSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/ordremission`;

    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 FETCH_ORDRE_MISSION_REQUEST");
        console.log("🌐 URL:", url);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group("✅ FETCH_ORDRE_MISSION_SUCCESS");
        console.log("📥 Ordres de mission:", resp.data.length);
        console.groupEnd();

        yield put(fetchOrdreMissionSuccess(resp.data || []));
        yield put(setOrdreMissionLoading(false));
    } catch (error) {
        console.group("❌ FETCH_ORDRE_MISSION_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(fetchOrdreMissionFail(error.message));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur chargement ordres de mission",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}

// ===================== FETCH BY ID =====================
export function* fetchOrdreMissionByIdSaga(action) {
    const token = sessionStorage.getItem('token');
    const id = action.payload;
    const url = `${API_BASE_URL}/api/ordremission/${id}`;

    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 FETCH_ORDRE_MISSION_BY_ID_REQUEST");
        console.log("🆔 ID:", id);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group("✅ FETCH_ORDRE_MISSION_BY_ID_SUCCESS");
        console.log("📥 Ordre de mission:", resp.data);
        console.groupEnd();

        yield put(fetchOrdreMissionByIdSuccess(resp.data));
        yield put(setOrdreMissionLoading(false));
    } catch (error) {
        console.group("❌ FETCH_ORDRE_MISSION_BY_ID_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(fetchOrdreMissionByIdFail(error.message));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Ordre de mission introuvable",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}

// ===================== CREATE =====================
export function* createOrdreMissionSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/ordremission`;
    const data = action.payload;

    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 CREATE_ORDRE_MISSION_REQUEST");
        console.log("📊 Données:", data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data, token });

        console.group("✅ CREATE_ORDRE_MISSION_SUCCESS");
        console.log("📥 Ordre de mission créé:", resp.data);
        console.groupEnd();

        yield put(createOrdreMissionSuccess(resp.data));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Ordre de mission ajouté",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ CREATE_ORDRE_MISSION_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        const errorMessage = extractErrorMessage(error, "Erreur lors de l'ajout");
        yield put(createOrdreMissionFail(errorMessage));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }
}

// ===================== UPDATE =====================
export function* updateOrdreMissionSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const data = action.payload.payload;

    const url = `${API_BASE_URL}/api/ordremission/${id}`;
    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 UPDATE_ORDRE_MISSION_REQUEST");
        console.log("🆔 ID:", id);
        console.log("📦 Payload:", payload);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data, token });

        console.group("✅ UPDATE_ORDRE_MISSION_SUCCESS");
        console.log("✅ Updated:", resp.data);
        console.groupEnd();

        yield put(updateOrdreMissionSuccess(resp.data));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Ordre de mission mis à jour",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ UPDATE_ORDRE_MISSION_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        const errorMessage = extractErrorMessage(error, "Erreur lors de la mise à jour");
        yield put(updateOrdreMissionFail(errorMessage));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }
}

// ===================== DELETE =====================
export function* deleteOrdreMissionSaga(action) {
    const token = sessionStorage.getItem('token');
    const id = action.payload;
    const url = `${API_BASE_URL}/api/ordremission/${id}`;

    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 DELETE_ORDRE_MISSION_REQUEST");
        console.log("🆔 ID:", id);
        console.groupEnd();

        yield call(deleteRequest, { url, token });

        console.group("✅ DELETE_ORDRE_MISSION_SUCCESS");
        console.log("🗑️ Supprimé:", id);
        console.groupEnd();

        yield put(deleteOrdreMissionSuccess(id));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Ordre de mission supprimé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ DELETE_ORDRE_MISSION_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        yield put(setOrdreMissionLoading(false));

        let errorMessage = "Erreur lors de la suppression";

        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
        } else if (error.message) {
            errorMessage = error.message;
        }

        yield put(deleteOrdreMissionFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur de suppression",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }
}

// ===================== FETCH ACTIFS =====================
export function* fetchOrdreMissionActifsSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/ordremission/actifs`;

    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 FETCH_ORDRE_MISSION_ACTIFS_REQUEST");
        console.log("🌐 URL:", url);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group("✅ FETCH_ORDRE_MISSION_ACTIFS_SUCCESS");
        console.log("📥 Ordres de mission actifs:", resp.data.length);
        console.groupEnd();

        yield put(fetchOrdreMissionActifsSuccess(resp.data || []));
        yield put(setOrdreMissionLoading(false));
    } catch (error) {
        console.group("❌ FETCH_ORDRE_MISSION_ACTIFS_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(fetchOrdreMissionActifsFail(error.message));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur chargement ordres actifs",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}

// ===================== FETCH EN COURS =====================
export function* fetchOrdreMissionEnCoursSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/ordremission/en-cours`;

    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 FETCH_ORDRE_MISSION_EN_COURS_REQUEST");
        console.log("🌐 URL:", url);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group("✅ FETCH_ORDRE_MISSION_EN_COURS_SUCCESS");
        console.log("📥 Ordres de mission en cours:", resp.data.length);
        console.groupEnd();

        yield put(fetchOrdreMissionEnCoursSuccess(resp.data || []));
        yield put(setOrdreMissionLoading(false));
    } catch (error) {
        console.group("❌ FETCH_ORDRE_MISSION_EN_COURS_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(fetchOrdreMissionEnCoursFail(error.message));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur chargement ordres en cours",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}

// ===================== FETCH BY PERIOD =====================
export function* fetchOrdreMissionByPeriodSaga(action) {
    const token = sessionStorage.getItem('token');
    const { dateDebut, dateFin } = action.payload;
    const url = `${API_BASE_URL}/api/ordremission/periode?dateDebut=${dateDebut}&dateFin=${dateFin}`;

    yield put(setOrdreMissionLoading(true));

    try {
        console.group("🔵 FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST");
        console.log("📅 Période:", dateDebut, "→", dateFin);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group("✅ FETCH_ORDRE_MISSION_BY_PERIOD_SUCCESS");
        console.log("📥 Ordres trouvés:", resp.data.length);
        console.groupEnd();

        yield put(fetchOrdreMissionByPeriodSuccess(resp.data || []));
        yield put(setOrdreMissionLoading(false));
    } catch (error) {
        console.group("❌ FETCH_ORDRE_MISSION_BY_PERIOD_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(fetchOrdreMissionByPeriodFail(error.message));
        yield put(setOrdreMissionLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur chargement par période",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}